var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.65385C6.99512 3.65385 4.15385 6.49512 4.15385 10C4.15385 13.5049 6.99512 16.3462 10.5 16.3462C14.0049 16.3462 16.8462 13.5049 16.8462 10C16.8462 6.49512 14.0049 3.65385 10.5 3.65385ZM3 10C3 5.85786 6.35786 2.5 10.5 2.5C14.6421 2.5 18 5.85786 18 10C18 14.1421 14.6421 17.5 10.5 17.5C6.35786 17.5 3 14.1421 3 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.65382C10.8186 6.65382 11.0769 6.91211 11.0769 7.23074V9.99997C11.0769 10.3186 10.8186 10.5769 10.5 10.5769C10.1814 10.5769 9.92308 10.3186 9.92308 9.99997V7.23074C9.92308 6.91211 10.1814 6.65382 10.5 6.65382Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92308 12.7693C9.92308 12.4506 10.1814 12.1923 10.5 12.1923H10.5073C10.8259 12.1923 11.0842 12.4506 11.0842 12.7693C11.0842 13.0879 10.8259 13.3462 10.5073 13.3462H10.5C10.1814 13.3462 9.92308 13.0879 9.92308 12.7693Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconError);
export default ForwardRef;